import { cn } from '@/lib/utils';
import { useExplorer } from '@/services/explorer/useExplorerProvider';
import { FC, PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

export interface FolderProps {
  directoryId: string;
  id: string;
  name: string;
  count: number;
}

export const Folder: FC<FolderProps> = ({ id, directoryId, name, count }) => {
  const prefix = useExplorer(state => state.prefix);
  return (
    <div>
      <Link
        to={`${prefix}/${directoryId}/${id}`}
        className={cn(
          'bg-secondary-std border-primary-std flex items-center gap-3 rounded-lg border px-3 py-3 leading-4'
        )}
      >
        <span className="flex aspect-square h-8 items-center justify-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_316_1484)">
              <path
                d="M19.25 17.25V9.75C19.25 8.64543 18.3546 7.75 17.25 7.75H4.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25Z"
                stroke="#444444"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.5 7.5L12.5685 5.7923C12.2181 5.14977 11.5446 4.75 10.8127 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V11"
                stroke="#444444"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_316_1484">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        <div className="flex flex-col text-left">
          <p>{name}</p>
          <p className="text-secondary-std text-sm">
            {count} item{count !== 1 && 's'}
          </p>
        </div>
      </Link>
    </div>
  );
};
export const FolderList: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="my-3 flex flex-col gap-2">
      <label className="text-secondary-std mx-5 text-sm">Folders</label>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(12rem,1fr))] gap-5 px-5">{children}</div>
    </div>
  );
};
